<div class="wrapper">
	<div class="header-wrapper">
		<h2 class="title">{{ 'recom_art.title' | translate }}</h2>
		<p class="description">
			{{ 'recom_art.desc' | translate }}
		</p>
	</div>
	<div class="content_block" role="region" aria-label="Content block">
		<ion-row role="region" aria-label="Content section">
			<ion-col size="4" *ngFor="let article of articlesList; let i = index; trackBy: trackBy">
				<div class="card-item" [class.selected]="showAmount(article) > 0" role="region" aria-label="Card item">
					<ion-icon
						[class.active]="showAmount(article) > 0"
						src="../../../assets/dean_and_david/selected_item.svg"
						class="selected_item_icon"
						role="img"
						aria-label="Icon representing article amount"
					>
					</ion-icon>
					<p class="price">
						{{ isFromPrice(article) ? ('item_view.price_from' | translate) : '' }} {{ reloadPriceNew(article) }}
					</p>
					<div class="image-block" role="region" aria-label="Image block">
						<ion-img class="item_img" *ngIf="article.assets.medium" [src]="article.assets.medium" alt=""></ion-img>
						<ion-img
							class="default-img"
							*ngIf="!article.assets.medium"
							src="../../../assets/hausmanns/housman-yel-logo.svg"
							alt=""
							aria-hidden="true"
						></ion-img>
						<ion-icon
							class="plus"
							[src]="
								article.assets.medium
									? '../../../assets/olearys/plus_recommended.svg'
									: '../../../assets/olearys/plus_recommended_white.svg'
							"
							role="img"
							aria-label="Plus icon for recommended articles"
						></ion-icon>
					</div>
					<div class="info-block" role="region" aria-label="Information block">
						<h3 class="name">
							{{ article.name | langObservable | async }}
						</h3>
					</div>
					<div class="footer-section" role="region" aria-label="Footer section">
						<div
							class="add-button"
							*ngIf="showAmount(article) === 0"
							(click)="selectArticle(article)"
							(keydown.enter)="selectArticle(article)"
							(keydown.space)="selectArticle(article)"
							role="button"
							tabindex="0"
						>
							<p>Add</p>
						</div>
						<div *ngIf="showAmount(article) > 0" class="quantity-selector" role="region" aria-label="Amount display">
							<ion-icon
								(click)="decreaseQuantity(article)"
								(keydown.enter)="decreaseQuantity(article)"
								(keydown.space)="decreaseQuantity(article)"
								class="quantity-btn"
								src="../../../assets/dean_and_david/minus.svg"
								role="img"
								aria-label="Decrease quantity button"
								tabindex="0"
							></ion-icon>
							<p class="quantity">{{ showAmount(article) }}</p>
							<ion-icon
								class="quantity-btn"
								(click)="increaseQuantity(article)"
								(keydown.enter)="increaseQuantity(article)"
								(keydown.space)="increaseQuantity(article)"
								src="../../../assets/dean_and_david/plus.svg"
								role="img"
								aria-label="Increase quantity"
								tabindex="0"
							></ion-icon>
						</div>
					</div>
				</div>
			</ion-col>
		</ion-row>
	</div>

	<div class="footer-btn" role="region" aria-label="Footer buttons">
		<!-- <ion-button (click)="addArticlesToBasket()">{{ 'recom_art.btn_yes' | translate
			}}</ion-button> -->
		<ion-button (click)="addArticlesToBasket()" class="cancel-btn" aria-label="Add articles to basket">{{
			'short_info.close' | translate
		}}</ion-button>
	</div>
</div>
